export default {
  vote: {
    team: {
      about_title: 'Règles',
      about_con:
        "<p>1. Les membres de l'équipe peuvent inviter 2 amis à former une équipe pour participer au tirage au sort.</p>\
        <p>2. Les prix sont 1 jour VIP, 7 jours VIP, 30 jours VIP, téléphone, télévision, décodeur, carte de recharge.</p>\
        <p>3. Seuls les nouveaux appareils et  comptes identifiés comme nouveaux utilisateurs peuvent rejoindre l'équipe.</p>\
        <p>4. Chaque utilisateur dispose d'un maximum de 10 chances d'être tiré au sort.</p>\
        <p>5. L'activité dure jusqu'au 25 décembre 2019.</p>\
        <p>6. StarTimes ON se réserve le droit d'interprétation finale.</p>",
      my_prizes: 'Mes prix',
      my_won: 'Prix: {0} jour VIP',
      share_btn: 'Partagez pour gagner plus de prix',
      invite_tips: 'Invitez 2 amis pour gagner de gros prix',
      invite_btn: 'Dites à vos amis de vous rejoindre',
      invite_btn2: 'Inscrivez-vous et dites à vos amis',
      share10_1: 'Fier de vous!',
      share10_2: 'Vous avez formé 1-10 équipes!',
      invite_con: 'Rejoignez mon équipe et obtenez un pack VIP gratuitement.',
      invite_ima: "{0} vous invite à rejoindre l'équipe pour gagner des prix VIP et des gros prix.",
      ima_saved: 'Enregistré dans le dossier local',
      copied: 'copié',
      copy_text: 'COPIE',
      search_team: 'Recherchez une équipe',
      search: 'CHERCHER',
      search_nores: 'Oups, aucun résultat trouvé.',
      join: "Rejoignez l'équipe",
      join_s: 'JOINDRE',
      reserves: 'Le prix sera effectif immédiatement dans ME.',
      form_late: 'Oups, vous êtes en retard, formez une nouvelle équipe.',
      form_newbtn: 'Formez une nouvelle équipe',
      form_succ: 'Félicitations! Vous avez réussi à faire équipe, vous avez 1 chance de gagner un cadeau VIP!',
      form_noform: "Désolé, vous n'avez pas formé d'équipe. Partagez à vos amis pour qu'ils vous rejoignent!",
      boardcast_con: '{0} a gagné {1}!',
      invite_tip: "{0} <br/>vous invite à rejoindre l'équipe et à gagner des prix!",
      full_team: "Désolé, l'équipe est au complet.",
      follow_team: 'Les équipes suivantes ont encore une place, rejoignez-les!',
      invite_won: '{0} personnes ont déjà remporté le VIP.',
      team_id: "ID de l'équipe",
      invite_infotit: 'Regardez la télévision en direct et profitez du meilleur contenu VOD.',
      joinpop_newuser: 'On vous attend, cliquez pour devenir membre.',
      change: 'Changement',
      joinpop_olduser:
        'Mon ami. Seul un nouvel utilisateur peut participer. Vous pouvez inviter des amis et former une nouvelle équipe pour gagner des prix.',
      download_tip: "Téléchargez l'apk maintenant? (12M)",
      show_lucky: 'Partagez ma chance',
      download_join: 'Téléchargez pour participer maintenant',
      have_team: "Vous ne pouvez avoir qu'une seule équipe à la fois.",
      input_error: "Veuillez entrer un identifiant d'équipe valide.",
      network_error: 'Erreur réseau.',
      tips: `Tips: <br/>Le prix VIP que vous avez gagné prend effet aujourd'hui.`,
      no_awards: 'Aucun prix pour le moment.',
      draw_title: 'Dessine ton cadeau',
      draw_button: 'Jouez',
      draw_none: 'Désolé, vous aurez plus de chance la prochaine fois.',
      my_won_one: 'Prix: {0} jour VIP',
      facebook: 'Facebook',
      whatsapp: 'Whatsapp',
      xender: 'Xender',
      download: "Enregistrer l'image",
      copy: 'Copier le lien',
      download_apk: 'Download Now',

      //add
      shareTitle: 'Make A Team to Win Free VIPS',
      shareText: 'Join my team and send you VIP to watch it all for free',
      countdownTitle: 'Remaining',
      enterID: "entrer l'ID de l'équipe",
      welcome: 'Bienvenue',
      newuser_popup: 'si vous avez été invité par des amis',
      or: 'ou',

      //no need
      prize_step: 'Suivez les étapes ci-dessous pour gaganer le prix.'
    },
    euro: {
      rules: 'Les Prix',
      rule_title: `<p style="color:#F3953A;font-weight:bold;font-size:16px;line-height:20px">Des règles et des Prix</p>`,
      rule_text: `<p>1.Temps d'activité:</p>
      <p>La période d'activité est du 7 juin au 13 juillet, et nous ferons deux prédictions:</p>
      <p>a.Du 7 juin au 19 juin, prédisant où chaque équipe de chacun des six groupes terminera et les quatre meilleures équipes classées troisième qui iront à la phase à élimination directe;</p>
      <p>b.Du 24 juin au 6 juillet, prédisant quelle équipe remportera le match au tour suivant et quelle équipe obtiendra la couronne en finale.</p>
      <p>2.Prix des activités:</p>
      <p>Prix de prédiction:</p>
      <p>Forfait Max graduit d’un an.</p>
      <p>Prix chanceux:</p>
      <p>Forfait Max graduit de 1 mois</p>
      <p>Forfait Max graduit de 1 semaine</p>
      <p>Forfait Max graduit de 3 jours</p>
      <p>Forfait Max graduit de 1 jour.</p>
      <p>3.Règles d'activité:</p>
      <p>a.Tous doivent s'inscrire et se connecter avant de participer à l'activité de prédiction;</p>
      <p>b.Seulement si vous associez votre carte DVB à votre compte OTT, vous pouvez avoir unechance de gagner le prix de prédiction.</p>
      <p>c.Participez pour obtenir des points. En phase de groupes, vous obtiendrez 2 points à chaque fois que vous prédisez correctement la position d'une équipe, et vous obtiendrez 1 point pour chaque équipe dans les 4 meilleures équipes troisièmes, soit un total de 52 points. Lors de la phase à élimination directe, vous devez prédire avant le début du jeu, sinon vous n'obtiendrez pas de points pour ce jeu. Vous obtiendrez 3 points pour chaque équipe en huitièmes de finale et en quarts de finale, et vous obtiendrez 4 points pour chaque équipe en demi-finale et en finale, soit un total de 48 points. Si vous participez à ces deux pronostics, vous avez la chance d'obtenir 100 points. Enfin, vous obtiendrez des récompenses chanceuses en fonction de vos points.</p>
      <p>4.Règles d'attribution:</p>
      <p>a.Prix de prédiction: </p>
      <p>Les gagnants du prix de prédiction seront choisis au hasard parmi les personnes quiprédisent le plus précisément le 25 juin et le 13 juillet. Les résultats seront affichés sur la page Facebook et de prédiction.</p>
      <p>b.Prix chanceux: </p>
      <p>Points: >=90, forfait Max 1 moi</p>
      <p>Points: <90 et >=70, forfait Max 1 semaine</p>
      <p>Points: <70 et >=50, forfait Max 3 jours</p>
      <p>Points: <50 et >=30, forfait Max 1 jou</p>
      <p>Pendant l'événement, si vous vous connectez plus de 10 jours, vous gagnerez sûrement un prix chanceux.</p>
      <p>Ces prix seront versés sur le compte des gagnants dans les 3 à 5 jours ouvrables suivant la fin de l’événement.</p>
      <p>5.Informations complémentaires</p>
      <p>a.Vous devez fournir un numéro de téléphone exact et le garder débloqué. Le numéro de téléphone est un certificat important pour l'attribution des prix;</p>
      <p>b.L'enregistrement malveillant est interdit. En cas d'enregistrement malveillant,l'organisateur a le droit d'annuler la qualification de l'événement et se réserve le droit de poursuivre sa responsabilité légale;</p>
      <p>c.La date limite de remboursement est le 20 juillet, si nous ne parvenons pas à vous contacter avant la date limite, il sera considérée comme invalide.</p>
      <p>d.L'organisateur se réserve le droit de modifier ces termes et réserve le droit d'interprétation finale.</p>`,
      rule_text_ug: `<p>1.Temps d'activité:</p>
      <p>La période d'activité est du 7 juin au 13 juillet, et nous ferons deux prédictions:</p>
      <p>a.Du 7 juin au 19 juin, prédisant où chaque équipe de chacun des six groupes terminera et les quatre meilleures équipes classées troisième qui iront à la phase à élimination directe;</p>
      <p>b.Du 24 juin au 6 juillet, prédisant quelle équipe remportera le match au tour suivant et quelle équipe obtiendra la couronne en finale.</p>
      <p>Outre ces deux prédictions, il y aura quatre loteries pour tous les utilisateurs qui participent à l'activité de prédictions et remplissent les conditions, le 18 juin, 25 juin, 1er juillet, 11 juillet.</p>
      <p>2. Prix des activités:</p>
      <p>Prix de prédiction:</p>
      <p>Premier prix : 10M UGX (Prix individuel)</p>
      <p>Deuxième prix : Senke Motorcycle (3 meilleurs scores)</p>
      <p>Troisième prix : StarTimes TV 32 pouces</p>
      <p>Quatrième Prix : Footbal</p>
      <p>Prix de loteries:</p>
      <p>Premier prix : Senke Motorcycle (2 clients chanceux)</p>
      <p>Deuxième prix : StarTimes TV 32 pouces</p>
      <p>Troisième prix : Euro 2020 Football</p>
      <p>Quatrième Prix : maillot de l’EURO 2020</p>
      <p>Prix chanceux </p>
      <p>Forfait Max graduit de 1 mois</p>
      <p>Forfait Max graduit de 1 semaine</p>
      <p>Forfait Max graduit de 3 jours</p>
      <p>Forfait Max graduit de 1 jour</p>
      <p>3. Règles d'activité:</p>
      <p>a.Tous doivent s'inscrire et se connecter avant de participer à l'activité de prédiction;</p>
      <p>b.Seulement si vous associez votre carte DVB à votre compte OTT, remplissez au moins l'une des conditions suivantes pendant cette période de l'événement du 1er juin au 11 juillet et avant le tirage au sort, alors vous pouvez avoir une chance de gagner des prix physiques: Prédiction Award et Lottery Award</p>
      <p>i.Abonnez-vous à UGX 20 000/- sur le décodeur d'antenne pour le bouquet de basique.Si sur le bouquet Nova, metterz à niveau de bouquet Basique puis abonnez-vous à l'UGX 20 000/-;</p>
      <p>ii.Abonnez-vous au bouquet mensuel classique au moins une fois sur le décodeur TNT;</p>
      <p>iii.Abonnez-vous au bouquet mensuel Smart au moins une fois sur le décodeur TNT;</p>
      <p>iv.Abonnez-vous au Bouquet mensuel Super au moins une fois le décodeur TNT;</p>
      <p>v.Achetez un nouveau décodeur et activez-le;</p>
      <p>c.Participez pour obtenir des points. En phase de groupes, vous obtiendrez 2 points à chaque fois que vous prédisez correctement la position d'une équipe, et vous obtiendrez 1 point pour chaque équipe dans les 4 meilleures équipes troisièmes, soit un total de 52 points. Lors de la phase à élimination directe, vous devez prédire avant le début du jeu, sinon vous n'obtiendrez pas de points pour ce jeu. Vous obtiendrez 3 points pour chaque équipe en huitièmes de finale et en quarts de finale, et vous obtiendrez 4 points pour chaque équipe en demi-finale et en finale, soit un total de 48 points. Si vous participez à ces deux pronostics, vous avez la chance d'obtenir 100 points. Enfin, vous obtiendrez des récompenses chanceuses en fonction de vos points.</p>
      <p>4. Règles d'attribution:</p>
      <p>a.Prix de prédiction: </p>
      <p>Les gagnants du prix de prédiction seront choisis au hasard parmi les personnes qui prédisent le plus précisément le 25 juin et le 13 juillet. Les résultats seront affichés sur la page Facebook, le page de prédiction et Sanyuka TV.</p>
      <p>b.Prix de loteries:</p>
      <p>Les gagnants sont choisis au hasard parmi tous ceux qui remplissent les conditions de participation les 18 juin, 25 juin, 1er juillet, 11 juillet;</p>
      <p>Pendant l'événement, si vous vous connectez plus de 10 jours, vous gagnerez sûrement un prix chanceux. Les résultats seront affichés sur la page Facebook, le page de prédiction et Sanyuka TV.</p>
      <p>c.Prix chanceux: </p>
      <p>Points: >= 90, forfait Max 1 moi</p>
      <p>Points: <90 et >= 70, forfait Max 1 semaine</p>
      <p>Points: <70 et >= 50, forfait Max 3 jours</p>
      <p>Points: <50 et >= 30, forfait Max 1 jour</p>
      <p>Pendant l'événement, si vous vous connectez plus de 10 jours, vous gagnerez sûrement un prix chanceux.</p>
      <p>Pour les prix de prédiction et de loterie, ces prix physiques, les gagnants doivent contacter l'organisateur. Après la vérification nécessaire, les récompenses seront attribuées.</p>
      <p>Pour le prix chanceux, il sera crédité sur le compte des gagnants dans les 3 à 5 jours ouvrables suivant la fin de l'événement.</p>
      <p>5. Informations complémentaires</p>
      <p>a.Vous devez fournir un numéro de téléphone exact et le garder débloqué. Le numéro de téléphone est un certificat important pour l'attribution des prix;</p>
      <p>b.L'enregistrement malveillant est interdit. En cas d'enregistrement malveillant, l'organisateur a le droit d'annuler la qualification de l'événement et se réserve le droit de poursuivre sa responsabilité légale;</p>
      <p>c.La date limite de remboursement est le 20 juillet, si nous ne parvenons pas à vous contacter avant la date limite, il sera considérée comme invalide.</p>
      <p>d.L'organisateur se réserve le droit de modifier ces termes et conditions et le droit d'interprétation finale.</p>`,
      rule_text_gh: `<p>Soumettez votre pronostic pour le classement final de chaque groupe et les quatre meilleures équipes troisièmes <strong>avant le 19 juin</strong></p>
      <p>ET</p>
      <p>Votre pronostic pour le vainqueur de chaque match à élimination directe, jusqu'à la finale, <strong>au début de chaque match</strong></p>
      <p>pour courir la chance de gagner ces prix INCROYABLES!</p>
      <p><strong><u>Le Prix</u></strong></p>
      <p>Vous obtiendrez des points pour chaque prédiction correcte. Si vous faites partie des MEILLEURS prédicteurs, vous participerez à un tirage pour l'un des trois prix suivants!</p>
      <p>Techno fantôme 10</p>
      <p>Techno Camon 17</p>
      <p>Techno Spark 7</p>
      <p>Les gagnants sont annoncés sur la page Facebook et Instagram de StarTimes! Abonnez-vous dès aujourd'hui pour rester à jour</p>
      <p><strong><u>Rappelles toi!</u></strong></p>
      <p>Seuls les utilisateurs actifs des décodeurs StarTimes ou les utilisateurs VIP de l'APP sont éligiblespour participer. Vous devez fournir ces informations et un numéro de téléphone lors de la soumission de votre pronostic et pour recevoir le prix.</p>
      <p>La date limite pour réclamer votre prix est le 20 juillet. Si nous ne pouvons pas vous contacter, alors votre prix sera invalidé.</p>
      <p>*StarTimes se réserve le droit de modifier ces termes et conditions à tout moment sans préavis.</p>`,
      share: 'Partager',
      share_title: "Prédiction de l'EURO 2020",
      share_text: 'Je regarde Euro2020 sur StartimesON, et je peux gagner des prix en devinant le résultat du match. Venez me rejoindre maintenant!',
      confirm: 'Confirmer',
      cancel: 'Annuler',
      group: 'Groupe',
      third_teams_title: 'Choisissez les quatre meilleurs troisièmes',
      confirm_submit_info: 'Êtes-vous sûr de vos prédictions？',
      prize_title: 'LISTE DES PRIX',
      result_tips_success: 'Vous avez soumis vos pronostics avec succès!',
      result_tips_end: 'Cette prédiction est terminée, veuillez participer à la suivante.',
      sign_in: 'Connectez-vous',
      sign_in_info: 'Connectez-vous pour commencer votre prédiction!',
      vip_tips:
        "Veuillez vous assurer que vous avez acheté un bouquet ou lié votre décodeur DVB, ce qui est une condition préalable à l'obtention des prix:",
      dvb_link_decode: 'LIER DECODEUR',
      ott_get_vip: 'Obtenir un VIP',
      phone_tips: 'Afin de vous informer lorsque vous gagnez le prix, veuillez remplir les informations de contact correctes:',
      phone_error_info: 'Veuillez entrer un numéro de téléphone valide!',
      phone_placeholder: 'Veuillez entrer votre numéro de téléphone',
      phone_confirm_info:
        "Le numéro de téléphone est votre seule preuve de réception du prix. Veuillez le vérifier attentivement et vous ne pourrez plus le modifier après l'avoir soumis.",
      network_error: 'Mauvais réseau, veuillez vérifier votre réseau!',
      change_rank_tip: 'Cliquez sur les flèches pour classer les équipes',
      no_finish_tip: 'Vous devez choisir les 4 meilleures équipes troisièmes pour compléter votre pronostic!',

      // 二期补充
      next: 'SUIVANT',
      back: 'PRÉCÉDANT',
      no_finish_tip2: 'Veuillez compléter tous les pronostics avant de passer au tour suivant',
      no_participate: "Vous n'avez pas participé au dernier événement.",
      no_prize: "Malheureusement, vous n'avez pas gagné le prix la dernière fois!",
      get_prize: 'Félicitations à vous pour avoir obtenu ',
      get_point1: 'Vous avez gagné ',
      get_point2: " points, Pronostiquer d'en obtenir plus!",
      submit_success: "Vous avez soumis vos pronostics avec succès! Restez à l'écoute pour les résultats du tirage au sort!",
      swipe_tip: 'Glisser pour tout voir',
      loading: 'Chargement...'
    },
    africa: {
      rule: 'RÈGLE',
      share: 'PARTAGE',
      rule_title: `<p style="color:#CB043F;font-weight:bold;">Les règles</p>`,
      rule_text: `<p>1. Seulement le score de jeu de ce jour peut être prédit à l’avance, et ne peut pas être prédit après le début du jeu.</p><p>2. Après chaque pronostic, vous aurez la possibilité de participer au tirage au sort.</p><p>3. Si vous devinez correctement le score du match,vous gagnez 5 points.</p><p>Si vous devinez correctement le score d’une équipe en disant qui va gagner et/ou perdre, vous gagnez 3 points.</p><p>Si vous devinez correctement le score d’une équipe, vous gagnez 2 points.</p><p>Si vous devinez le résultat final (victoire, nul ou défaite), gagnez 1 point même si vous ne trouvez pas le score exact.</p><p>Instructions :</p><p>Les utilisateurs connectés sont éligibles pour les prévisions et le tirage au sort, tout en participant au classement des points.</p>`,
      prize_details: 'DÉTAILS DES PRIX',
      prize_details_text1: 'Les utilisateurs qui ont le plus de points seront récompensés par des motos',
      prize_details_text2: 'Les utilisateurs du second et du troisième seront récompensés MAXVIP à vie',
      prize_details_text3: 'Les utilisateurs du quatrième et du cinquième seront récompensés pour trois ans de membres',
      prize_details_text4: "Les utilisateurs du sixième au dixième seront récompensés de membre d'un an",
      fixture: 'CALENDRIER DES COURSES',
      africa_rank: 'CLASSEMENT PAR POINTS',
      points: 'Points: ',
      replay: 'REPLAY',
      predict: 'PRÉDITE',
      predicted: 'PRÉVU',
      live: 'EN DIRECT',
      over: 'TERMINÉ',
      my_points: 'Mes Points: ',
      my_ranking: 'Mon Classement: ',
      lottery_title: 'ZONE DE TIRAGE',
      lottery_des:
        'Chaque fois qu’une prédiction est faite, une chance de tirage au sort sera donnée, et les utilisateurs de décodeurs VIP ou LINK auront une autre chance.',
      lottery_left: 'Nombre de tirages restant: ',
      my_prize: 'MON PRIX',
      start: 'DÉBUT',
      has_got: 'a obtenu',
      more_vote_title: 'COMMENT OBTENIR PLUS DE TIRAGES',
      predict_btn: 'PREDIRE',
      predict_des: '1. Faire une prévision',
      ott_btn: 'ACHAT VIP',
      ott_des: '2. StarTimesON VIP intérêts',
      dvb_btn: 'CONNECTÉ',
      dvb_des: '3. StarTimes DVB intérêts',
      buy_btn: 'ACHETER',
      buy_des: '4. Achetez n’importe quelle quantité de VIP ou rechargez une fois',
      share_btn: 'PARTAGE',
      share_des: '5. Partager avec de nouveaux utilisateurs pour participer aux activités',
      lottery: 'Loterie',
      video_title: 'LES MOMENTS FORTS',
      confirm: 'CONFIRMER',
      lottery_no_left:
        'Avec chaque prédiction, il y a une chance pour plus de coups de chance! Acheter VIP et relier votre décodeur pour augmenter vos chances de gagner!',
      predict_success:
        'Préparez votre prédiction pour une chance de gagner! Achetez un VIP, connectez votre décodeur ou partagez pour augmenter vos chances de gagner!',
      lottery_success: 'Félicitations pour avoir gagné ',
      lottery_sorry: 'Merci d’avoir participé!',
      lottery_again: 'Félicitations pour avoir eu une chance de gagner!',
      no_left: ' Votre loterie est épuisée!',
      to_signin: 'Participer à l’événement après s’être connecté! Participer à l’événement pour gagner de grands prix!',
      lottery_btn: 'JOUEZ',
      add_btn: 'booster les chances',
      sign_btn: 'se connecter',
      continue_btn: 'CONTINUEZ',
      // 补充
      before_start: "L'événement n'a pas débuté",
      after_end: "l'événement est terminé",
      ok: 'OK',
      loading: 'Chargement…',
      download: 'TÉLÉCHARGER'
    },
    appvote: {
      select_one: 'Sélectionnez une option',
      select_more: 'Sélectionner un ou plusieurs',
      pre_vote: 'Le vote après les élections',
      vote: 'Vote',
      download_btn: 'Télécharger',
      vote_success: "Le vote a été couronné de succès ! Téléchargez Startimes ON pour voir les résultats et d'autres superbes vidéos à venir !"
    },
    bssregister: {
      rule_btn: 'RULES',
      rule: '<p style="color:#55A081;font-weight:bold;">RULES</p>',
      rule_text: `\nOnline Audition\n\n1. Time of online audition: 9 Nov, 2024- 22 Dec, 2024\n\n2. Conditions\n\nⅠ.Record yourself singing the whole song\n\nⅡ.Record yourself immediately, do not edit or modify anything.\n\nⅢ.The song should carry all the sound characteristics that show the singer's feelings\n\nⅣ.The participant has to record his/her appearance. Fake singing is not allowed.\n\n3. How to register\n\nI. Online registration- StarTimes ON APP\n\nParticipants should record themselves singing the whole song, then upload their videos on YouTube/Tik Tok/Instagram (Copy link); Then download and open STARTIMES ON APP, enter the BSS interview section; fill in your important information, put your YouTube link while singing; submit, then wait for your work to be uploaded.\n\nII.Another way to register-Instagram\n\nRecord a video of yourself singing and then post it on Instagram, and put the hashtag #bssonlineaudition2024 and finally tag @startimestz *IMPORTANT: All the works of online participants will be reviewed for 48 hours after uploading, and the results will be placed in the next selections\n\n4.Rules\n\nAfter the publications, voting will officially open on StarTimes ON APP “Online Audition Election Voting Channel”. Until the end, 1~5 winners will qualify to enter the knockout stage of the competition.\n\nOffline Audition\n\n4. Time and place\n\nBSS interview dates\n\n• Nov 09 - 10 : Arusha 🇹🇿\n\n• Nov 16 - 17 : Mwanza 🇹🇿\n\n• Nov 23 - 24 : Kampala 🇺🇬\n\n• Nov 29 - 30 : Nairobi 🇰🇪\n\n• Dec 07 - 08 : Babati 🇹🇿\n\n• Dec 13 - 15 : Dar es Salaam 🇹🇿\n\n5. Method of interview\n\nCandidates who will participate in the offline interview are advised to go to the above mentioned locations due to the interview time.\n\n6. Selection rules\n\nThere are 5 opportunities for non-internet interviews in each interview (except Dar es Salaam), 4 expert judges will interview the participants with YES or NO. Participants who pass the interview that day will participate again in the second interview the next day in order to select those who will move forward in the competition.\n\n7. Others\n\nDue to the presence of many people who appear during the interview, the preparation of the session also takes place on the day of the interview. You are advised to arrive early at the interview location and follow the instructions. \n\n8. All Rights are Reserved by StarTimes `,
      loading: 'Loading...',
      name: 'NAME',
      sex: 'GENDER',
      male: 'Male',
      female: 'Female',
      select_placeholder: 'Please enter',
      birthday: 'DATE OF BIRTH',
      year: 'Year',
      month: 'Month',
      day: 'Day',
      number: 'PHONE NUMBER',
      number_error: 'Please enter correct phone number',
      country: 'COUNTRY',
      city: 'CURRENT RESIDENCE',
      profession: 'OCCUPATION',
      link: 'VIDEO LINK',
      link_placeholder: 'Video links for Tiktok/Instagram/Youtube',
      howto_getlink: 'HOW TO GET THE VIDEO LINK?',
      end_text: 'Sorry, registration is closed',
      offway_title: 'OFF-LINE REGISTRATION',
      offway_text: `Auditions for Bongo Star Search season 15 will be held in Arusha, Mwanza, Kampala Uganda, Nairobi Kenya, Babati and Dar es Salaam.<br/>It will start in Arusha on 09/11/2024. Get excited about this great opportunity. Regarding how to join the competition, please click on the link. Don't forget there are more opportunities waiting for you!`,
      success_title: 'Registration successful',
      success_text:
        'If approved, we will review your video and your video will be displayed on the APP within 48 hours. Don’t forget you’ve signed up!',
      ok: 'OK',
      share: 'SHARE',
      share_title: 'You are the next bingo star',
      share_text: 'Record a video of yourself singing, register NOW! This opportunity is yours.',
      ke: 'Kenya',
      ug: 'Uganda',
      tz: 'Tanzania',
      profession_list: [
        'Sales/Marketing',
        'Accounting/Management',
        'Projects/Quality',
        'Information Technology/Network/Telecommunications',
        'Non-current Assets/Construction',
        'Finance/Funds',
        'Transportation/Logistics',
        'Manufacturing/Production',
        'Information Technology Equipment/Art/Craftsmanship',
        'Consulting/Legal/Education',
        'Service Sector',
        'Energy/Environment',
        'Agriculture',
        'Scientific Research',
        'Temporary Work/On-the-job Training/Others'
      ],
      title1: 'PROCESS OF JOINING ONLINE',
      title2: 'OTHER REGISTRATION METHODS',
      title3: 'HIGHLIGHTS',
      submit: 'SUBMIT'
    },
    bssvote: {
      rule_btn: 'RULES',
      rule: '<p style="color:#55A081;font-weight:bold;">RULES</p>',
      rule_text: `\nFrom Nov 9 to Dec 22, you have 5 votes every day after logging in. Votes will be totaled and valid until the end of the activity.\n\nYou can vote for any contestant you like!\n\nShare the link to your friends and ask them to download the StarTimes ON App to get more votes! You will get 5 more votes for each new user. The more new users you bring in, the more votes you get! And also, if you connect your Decoder with the App, or if you are a VIP of the App, you will get 20 more votes!\n\nEvery time you vote, you will get one chance to get StarTimes Decoder, Dish, or Max VIP of the Month for StarTimes ON and Coupons.\n\nPrizes will be awarded the next business day in Me-> My Coupons.\n\nThe top 10 candidates with the most votes will be able to enter the final interview, and finally 5-10 candidates will be selected by the teacher to participate in 2024BSS S15.`,
      new_info: 'Participate in the vote to get more votes',
      way_link: 'HOW TO GET MORE VOTES?',
      vote_left: 'Number of remaining votes: ',
      vote: 'VOTE',
      more_singer: 'VIEW ALL PARTICIPANTS',
      tosign: 'SIGN UP',
      tofinish: 'COMPLETE IT',
      finished: 'COMPLETED',
      invite: 'INVITE',
      invite_text: 'Successfully invited friends:',
      info: `Every time you vote,<br />you will have a chance to win prizes.`,
      lottery_left: 'REMAINING DRAWS:',
      tip: 'FIND PRIZE ON ME -> MY COUPON',
      vote_title: 'VOTER FOR YOUR CHOICE',
      close: 'CLOSE',
      share_title: 'Beyond Borders Si Mchezooo!',
      share_text:
        'The choice is yours! Choose the candidate you like and help him participate in the Bongo Star Search 2024 participant search stage.',
      ok: 'OK',
      share: 'SHARE',
      cancel: 'CANCEL',
      before_start: 'Voting starts on November 9th, so stay tuned!',
      after_end: 'Sorry, voting is closed',
      voteleft0: 'Sorry, your remaining votes are 0',
      get_more: 'HOW TO GET MORE VOTES?',
      nomore: 'The vote failed. Not enough votes',
      fail1: 'success! Share with friends to get more votes',
      fail2: 'success! You will get prizes by participating in the game',
      sign_tip: 'Go and participate in lucky draw',
      nomore_vote: 'Go vote for a chance to win good to draw. Every time you vote, you will have a chance to win prizes.',
      win_morevote: 'Congratulations! You got {0} votes again!',
      win_again: 'Congratulations! You have one more chance!',
      win_normal: 'Congratulations! You got {0}! Rewards will be issued on the second business day of My Me->Coupon.',
      sorry: 'Thanks for participation',
      getott: 'LIPIA VIP',
      getdvb: 'CONNECT DIKODA&APP',
      sign: 'REGISTER',
      toinvite: 'INVITE FRIENDS',
      title1: 'VOTE FOR THE CONTESTANT YOU SUPPORT',
      title2: 'HOW TO GET MORE VOTES?',
      title3: 'LUCK DRAW',
      title4: 'MORE VIDEOS'
    },
    bssresult: {
      rule_btn: 'RULES',
      share_btn: 'SHARE',
      rule_title: '<p style="color:#55A081;font-weight:bold;">Rules for voting</p>',
      rule_text:
        '\n1. From Nov 9 to Dec 22, you have 5 votes every day after logging in. Votes will be totaled and valid until the end of the transaction.\n\n2. You can vote for any contestant you like!\n\n3. Give the link to your friends and ask them to download the StarTimes ON App to get more votes! You will get 5 more votes for each new user. The more new users you bring in, the more votes you get! And also, if you connect your Decoder with the App, or if you are a VIP of the App, you will get 20 more votes!\n\n4. Every time you vote, you will get one chance to get StarTimes Decoder, Dish, or Max VIP of the Month for StarTimes ON and Coupons.\n\n5. Prizes will be awarded the next business day in Me-> My Coupons.\n\n6. The top 10 candidates with the most votes will be able to enter the final interview, and finally 5-10 candidates will be selected by the teacher to participate in 2024BSS S15.',
      share_title: 'You are the next Bongo star.',
      share_text:
        'The choice is yours! Choose the candidate you like and help him participate in the Bongo Star Search 2024 participant search stage.',
      ok: 'OK',
      highlights: 'MORE VIDEOS'
    },
    bsspopular: {
      rule_btn: 'RULES',
      share_btn: 'SHARE',
      rule_title: '<p style="color:#55A081;font-weight:bold;">Voting rules</p>',
      rule_text:
        '<p>1.During the event, you have 5 votes every day after logging in. The votes will be accumulated and valid until the end of the event.</p><p>2.You can vote for any participant you like!</p><p>3.Share the link with your friends and have them download the StarTimes ON App to get more votes! You will get 5 more votes for each new user. The more new users you bring, the more votes you get! And also if you link your Dikoda to the App, or become a VIP of the App, you will get 20 more votes!</p><p>4.Every time you vote, you will increase your chances of winning prizes.</p><p>5.Each user can get up to 50 votes per day by sharing the link with new users, and the number of votes received during the event will not exceed 1,000.</p><p>6.Prizes will be awarded the next day. Click "Me"->" My Coupons"and you will see your prizes.</p>',
      share_title: 'StarTimes ON',
      share_text: 'Bongo Star Search Season 15 Voting window for the most popular participants!!',
      ok: 'OK',
      cancel: 'CANCEL',
      to_more_vote: 'HOW TO GET MORE VOTES?',
      vote_left: 'Number of remaining votes:',
      vote: 'VOTE',
      tosign: 'Sign Up',
      tofinish: 'COMPLETE IT',
      finished: 'COMPLETED',
      invite: 'INVITE',
      invite_text: 'SUCCESSFULLY INVITE FRIENDS:',
      info: 'Every time you vote,you will have a chance to win prizes.',
      lottery_left: 'REMAINING DRAWS:',
      tip1: 'Coupons and prizes can be viewed here, click “ME” then “my coupon”',
      tip2: 'Users who win prizes,contact us to collect them from designated stores',
      vote_title: 'VOTE FOR YOUR FAVORITE',
      close: 'CANCEL',
      before_after: 'Activity has not started!',
      after_end: 'Activity is over!',
      voteleft0: 'Sorry, your remaining vote is 0.',
      nomore: 'The vote has failed. There are not enough votes left.',
      fail1: 'Successful! Involve friends to get more votes.',
      fail2: "Successful! You've got a chance to win a prize by going through the game on this page.",
      sign_tip: 'Please register to start the lucky draw.',
      nomore_vote: 'Go vote to win a lucky draw. Every time you vote, you have a chance to win a prize.',
      win_normal: 'Congratulations! You got {0}! Prizes will be awarded the next day. Click "Me"->" My Coupons"and you will see your prizes.',
      sorry: 'Thanks for participation.',
      has_got: 'has got'
    }
  },
  native: {
    guide: {
      channellistbottom: "Il n'y a plus de chaînes",
      channelslist: ' chaînes',
      channellist: ' chaîne',
      searchbox: 'Nom ou code de la chaîne',
      searchresults: ' résultats trouvés pour ',
      search1result: '1 résultat trouvé pour ',
      search0result: 'Aucun résultat trouvés pour ',
      noepg: "Aucun EPG n'est accessible pour aujourd'hui",
      tvguide: 'Guid',
      network_error: 'Erreur réseau.'
    },
    exchangecode: {
      code: 'Code:',
      sure: 'Oui',
      tips: 'Félicitations! ! ! Remplissez le code  pour échanger la récompense ! ! !',
      no_sign: 'Seuls les nouveaux utilisateurs enregistrés peuvent participer à cette activité. Alors inscrivez-vous dès maintenant ! ! !',
      old_sign: 'Seuls les nouveaux utilisateurs peuvent participer à cette activité ! ! !',
      error_code: "Ce code n'est pas valide, veuillez vérifier et re-remplir ! ! !",
      repeat_code: 'Vous avez déjà participé à cette activité et ne pouvez plus y participer ! ! !',
      repeat_device: "Cet appareil a déjà participé à l'activité et ne peut plus y participer ! ! !",
      h5_call: "Le code ne peut être utilisé que dans l'application, veuillez télécharger et installer l'application ! ! !",
      success_tip1: 'Félicitations! ! ! Vous bénéficiez de ',
      success_tip2: ', regardez la vidéo maintenant ! ! !',
      server_error: 'Erreur du serveur'
    }
  },
  template: {
    dvbActivity: {
      startimes_on_app: 'STARTIMES ON APP',
      download: 'TELECHARGER',
      rule: 'REGLE',
      rule_text:
        "<p>1. Un décodeur peut être liée au maximum au trois comptes de StarTimes ON, ce qui vous permettra de profiter gratuitement des émissions merveilleuses.</p><p>2. Remplissez votre numéro de carte et les six derniers chiffres de votre décodeur pour vérifier, dès que la vérification est validée, vous remplissez le numéro de téléphone pour lier.</p><p>3. Si le numéro de téléphone que vous avez rempli n'est pas enregistré, vous pouvez télécharger l'application selon des indices et puis faire l'enreigistrement avant la liaison.</p><p>4. Si le numéro a été enregistré, vous pouvez lier directement au décoduer.</p>",
      smart_card: 'NUMERO DE CARTE',
      decoder: 'NUMERO DE DECODEUR(les 6 derniers chiffres)',
      err_code12: 'Numéro de carte invalide',
      err_code13: 'Le numéro de carte et le numéro de décodeur ne correspondent pas.',
      err_code21: 'ÉCHEC DE LA LIAISON. La carte a été liée au-delà de la limite (au maximum de trois utilisateurs par décodeur)',
      next: 'Suivante',

      limit_tip1: 'Cette carte peut être liée au 3 utilisateurs au total. Actuellement lié au ',
      limit_tip2: ' comptes et peut être lié au ',
      limit_tip3: ' comptes encore.',
      wait_bind: 'Liaison en attente...',
      phone_number: 'Numéro de téléphone:',
      err_code1: 'Carte liée avec succès',
      err_code5: 'Faux numéro de téléphone',
      err_code15: "L'utilisateur a déjà liée à cette carte",
      bind: 'Activer',

      off: 'OFF',
      for_order_above: 'Pour ordre ci-dessus',
      coupon: 'coupon',
      recharge: 'Recharger',
      congratultions: 'Félicitations!',
      got_right: 'Vous avez bien activé StarTimes ON!',
      right_title1: 'Astuce Famille',
      right_content1: 'Liez 01 décodeur à 03 téléphones dans votre famille',
      right_title2: 'Chaîne en direct gratuite',
      right_content2: 'regardez gratuitement toutes les chaînes en direct de votre bouquet',
      right_title3: 'Contenu VOD gratuit',
      right_content3: 'Profitez de toutes les vidéos à la demande gratuitement et sans abonnement supplémentaire',
      benefits: 'Activez vos bénéfices maintenant',
      highlights: 'Highlights',

      ok: 'BON',
      cancel: 'Annuler',
      server_error: 'Erreur du serveur',
      before_start: "L'événement n'a pas débuté",
      after_end: "l'événement est terminé"
    },
    vote: {
      share: 'PARTAGE',
      vote_left: 'VOTES RESTANTS:',
      vote: 'VOTER',
      sign_tip: 'login disponible ',
      ott_tip: 'Achetez OTT VIP disponible ',
      dvb_tip: 'Liaison carte DVB disponible ',
      pay_tip: 'Achetez les produits disponibles ',
      pay_dvb_tip: 'Subscribe StarTimes Decoder ',
      comment_tip: 'Poster un commentaire avec succès ',
      pay_mtn_tip: 'Subscribe ${0} MTN CallerTunez ',
      share_tip: "Partagez l'activité ",
      to_finish: 'Allez',
      finished: 'Terminé',
      to_buy: "S'abonnez",
      to_share: 'Partagez',
      more_vote: 'OBTENEZ PLUS DE VOTES',
      how_many_vote: 'Combien de votes voulez-vous donner à TA?',
      ok: 'OK',
      cancel: 'annulez',
      before_start: "L'activité n'a pas débuté!",
      after_end: "l'activité est terminé!",
      server_error: 'Erreur du serveur!',
      vote_success: 'Succès du vote! ',
      vote_error: 'Échec du vote! ',
      vote0_get_more: '0 votes restants, obtenez plus de votes! ',
      copied: 'Web link has been copied',
      no_support_copy: 'Copy is not supported on your browser, please try to make a long press to copy'
    },
    voteLottery: {
      sign_alert: '请登录后抽奖',
      lottery_left: 'LOTTERY LEFT:',
      has_got: 'has got',
      win_tip:
        'Kuponi na zawadi za wanachama zinaweza kutazamwa Tkwangu->Kuponi yangu baada ya tukio kuisha</br>Watumiaji wanaoshinda zawadi za vitu watawasiliana nawe ili kuzichukua kwenye maduka yetu yaliyoteuliwa',
      lottery0_get_more: '没有抽奖机会了，投票获取更多抽奖机会吧！',
      win_text: '恭喜你, 获得了',
      win_vote: 'xxx票!',
      win_thanks: '很抱歉没中奖',
      win_try_again: '恭喜你, 你还有一次机会!',
      my_prize: 'My Prize',
      loading: '加载中...',
      empty_list: '你还没有中奖哦'
    },
    guidebind: {
      share: 'Partager',
      ok: 'OK',
      cancel: 'Annuler',
      after_end: "L'événement est terminé",
      after_end_toast: "L'événement en cours est terminé. Please stay tuned to Startimes ON for more amazing discounts!",
      server_error: 'Erreur de serveur !',
      btn_down: 'Télécharger & utiliser',
      btn_sign: 'Se connecter & utiliser',
      link_not_bind: 'Pourquoi pas une récompense TV ?  >',
      btn_not_bind: 'Utiliser maintenant',
      link_bind: 'Obtenir un VIP mobile >',
      btn_bind: 'Rejoindre la promo TV',
      sign_in_content:
        '<div style="text-align: left;line-height: 20px;">Pour une meilleure expérience de la promotion de Pâques, n\'oubliez pas de vous <span style="color: #ffc107;font-weight: bold;">CONNECTER</span> avec vous même<br />1. <span style="color: #f44336;font-weight: bold;">1. Numéro de téléphone</span> <br />2. <span style="color: #f44336;font-weight: bold;">Numéro de carte</span> à puce comme <span style="font-weight: bold;">mot de passe</span>. <br />Ensuite, TOUS les films et émissions de télévision illimités seront disponibles et GRATUITS pour vous UNIQUEMENT !</div>'
    },
    userfission: {
      share: 'SHARE',
      like: 'LIKE',
      liked: 'LIKED',
      sure: 'SURE',
      join_btn: 'JOIN NOW',
      prize_title: 'Congratultions',
      share_title: 'ACTIVITY',
      like_title: 'ACTIVITY',
      video_title: 'JOIN AND ENJOY',
      step_title: 'HOW CAN I JOIN THIS ACTIVITY',
      ok: 'OK',
      cancel: 'Cancel',
      after_end: 'Sorry, the activity has ended!',
      server_error: 'Server error! Try again later.',
      country_error: 'The activity in the current country has not started yet, please wait a little!',
      sign_tip: 'Login to partiaipate in the activity',
      has_got: 'has got',
      congratultions1: 'Congratultions!!! You have got ',
      congratultions2: 'Your friend ${0} have got ',
      for_free: ' FOR FREE',
      my_bonus_btn: 'MY BONUS DETAIL >',
      my_bonus: 'Bonus details',
      first_share: 'FIRST TIME SHARE THIS PAGE TO YOUR FRIENDS, GET /*${0} IMMEDIATELY*/',
      has_share: 'YOU HAVE GOT /*${0}*/ LIKES FROM YOUR FRIENDS',
      share_excess: 'GET MORE LIKES from YOUR FRIENDS, GET /*MORE VIP*/',
      liked_excess: 'You have helped your friends get ',
      like_excess: 'LIKE FOR your friend, GET MORE VIP',
      like_no_excess: 'Many of your friends have received benefits, hurry up and participate in the activity to get FREE STARTIMES ON ',
      like_success: 'Successful! Thanks for your action.',
      like_limit_tip: 'The opportunity to like has reached the upper limit for today, open the StarTimes ON, participate in the ACTIVITY'
    },
    unitmember: {
      error_text: 'Veuillez entrer un numéro de téléphone valide.',
      placeholder: 'Numéro de téléphone',
      ok: 'BON',
      server_error: 'Erreur du serveur',
      before_start: "L'événement n'a pas débuté",
      after_end: "l'événement est terminé"
    }
  },
  clause: {
    comment: {
      title: '《Comments Guidelines》',
      desc1:
        "Lorsque vous utilisez StarTimes ON, vous entrez dans une communauté d'amis riche en contenu. Les lignes directrices suivantes permettent de s'assurer que tout le monde a une expérience amusante et agréable de StarTimes ON.",
      desc1:
        "Lorsque vous utilisez StarTimes ON, vous entrez dans une communauté d'amis riche en contenu. Les lignes directrices suivantes permettent de s'assurer que tout le monde a une expérience amusante et agréable de StarTimes ON.",
      desc2: 'Si vous pensez avoir vu un contenu qui viole ces directives, cliquez sur l\'icône "drapeau".',
      subTitle1: '- Spam et tromperie',
      content1:
        'La confiance est la base sur laquelle StarTimes ON est construit, et StarTimes ON ne tolère pas la publication de contenu destiné à tromper, induire en erreur ou escroquer les autres utilisateurs, ni le spam.',
      content1:
        'La confiance est la base sur laquelle StarTimes ON est construit, et StarTimes ON ne tolère pas la publication de contenu destiné à tromper, induire en erreur ou escroquer les autres utilisateurs, ni le spam.',
      subTitle2: '- Contenu sensible',
      content2:
        'Nous souhaitons protéger nos utilisateurs, en particulier les mineurs. Par conséquent, veuillez vous abstenir de publier des commentaires qui mettent en péril la sécurité des enfants.',
      content2:
        'Nous souhaitons protéger nos utilisateurs, en particulier les mineurs. Par conséquent, veuillez vous abstenir de publier des commentaires qui mettent en péril la sécurité des enfants.',
      subTitle3: '- Contenu violent ou dangereux',
      content3:
        "StarTimes ON n'autorise pas la publication de discours haineux, de comportements prédateurs, de contenus écrits de manière violente, d'attaques malveillantes et de contenus qui encouragent des comportements nuisibles ou dangereux.",
      content3:
        "StarTimes ON n'autorise pas la publication de discours haineux, de comportements prédateurs, de contenus écrits de manière violente, d'attaques malveillantes et de contenus qui encouragent des comportements nuisibles ou dangereux.",
      subTitle4: '- Articles contrôlés',
      content4: 'Veuillez ne pas mettre en vente sur StarTimes ON des produits contrôlés qui enfreignent les politiques locales.',
      subTitle5: '- Fausses informations',
      content5:
        "StarTimes ON n'autorise pas la publication de certains types de contenus mensongers ou trompeurs qui peuvent présenter un risque sérieux de préjudice extrême. Cela inclut des types spécifiques de fausses informations qui pourraient causer des dommages dans le monde réel (comme la promotion de remèdes ou de traitements nocifs), des types spécifiques de contenu qui sont manipulés technologiquement, ou du contenu qui interfère avec le processus démocratique.",
      desc3:
        "Veuillez vous conformer strictement à ces règles. Si votre comportement sur ou en dehors de la Plateforme nuit à nos utilisateurs, communautés, employés ou écosystème, nous pouvons prendre des mesures en fonction d'une combinaison de facteurs, y compris, mais sans s'y limiter, la gravité du comportement et le fait qu'il soit habituellement nuisible ou non. Dans le cas d'un tel comportement, nous pouvons suspendre les privilèges de parole de votre compte pour un comportement moins grave, ou résilier votre compte pour un comportement plus grave."
    },
    screen: {
      title1: 'Comment utiliser le cast',
      p1:
        "1.Etape 1 : Ouvrez l'application StarTimes sur votre récepteur et assurez-vous que l'appareil est connecté au même Wi-Fi que votre téléphone mobile.<br/>2.Etape 2 : Cliquez sur TV casting dans le coin supérieur droit du lecteur StarTimes App pour entrer dans l'interface de casting, sélectionnez le récepteur qui a téléchargé StarTimes App pour terminer le casting.",
      title2: 'Impossible de trouver le récepteur',
      p2:
        "Vous pouvez vérifier les éléments suivants :<br/>1. le récepteur a installé StarTimes App, si ce n'est pas le cas, vous pouvez ouvrir la boutique d'applications TV/box et télécharger gratuitement l'application StarTimes, puis caster pour le regarder.<br/>2. le récepteur est allumé et connecté au même Wi-Fi que le téléphone portable.<br/>3. l'appareil prend en charge le cast. Si vous ne pouvez pas le confirmer, nous vous suggérons de consulter le fabricant de l'appareil.<br/>4. les fonctions d'isolation AP et de mode invité du routeur ont été désactivées et le réseau d'amplificateurs de signaux n'est pas connecté. Si le cast n'est toujours pas normale, vous pouvez redémarrer le routeur et les autres périphériques réseau.<br/>5 .Pour les utilisateurs d'iOS 14 ou d'iPadOS 14, assurez-vous que les privilèges du réseau local ont été activés dans « Réglages-Privacité-Réseau local-StarTimes ».<br/>6. redémarrez l'application StarTimes et essayez à nouveau de caster après avoir confirmé qu'il n'y a pas de problème mentionné ci-dessus.",
      title3: "Comment résoudre l'échec du cast ?",
      p3:
        "Vous pouvez essayer les 2 solutions suivantes :<br/>1. vérifiez si la TV/box peut accéder au réseau normalement.<br/>2. si l'application StarTimes a été installée sur le dispositif de diffusion, si ce n'est pas le cas, vous pouvez ouvrir la boutique d'applications de la TV/box et télécharger gratuitement l'application « StarTimes » pour caster.",
      title4: 'Bégaiement lors du cast',
      p4:
        "1. Le réseau actuel ou le dispositif de diffusion d'écran n'est peut-être pas en mesure de prendre en charge la vidéo haute définition ; il est recommandé de réduire la définition de la vidéo afin d'assurer une lecture fluide de la vidéo.<br/>2. si l'récepteur peut accéder au réseau normalement<br/>3. si la vitesse du réseau de l'récepteur est stable<br/>4. s'il y a d'autres appareils qui occupent beaucoup de bande passante sur le même réseau.",
      title5: "Problèmes tels que le saut d'épisodes ou l'impossibilité de continuer lors du cast.",
      p5: "Il est recommandé de redémarrer l'application StarTimes pour recommencer le cast et de maintenir une connexion réseau normale.",
      title6: 'Pourquoi certaines vidéos ne sont-elles pas compatibles avec le cast ?',
      p6:
        "Certains contenus ne sont pas pris en charge pour être diffusés dans la scène de diffusion d'écran en raison de la demande du détenteur des droits d'auteur. Vous pouvez choisir dus lire directement sur votre téléphone portable ou dus regarder directement sur votre téléviseur.",
      title7: "Comment transférer l'écran vers un ordinateur pour le regarder ?",
      p7: "Pour l'instant, nous ne prenons pas en charge le cast sur ordinateur.",
      TVtitle: "Méthode d'utilisation de l'écran de projection",
      step1:
        '<span style="font-weight: bold;">1.</span> Première étape: Allumez le périphérique de projection et installez l\'application startimes sur le périphérique de projection, vérifiez que le périphérique est connecté au même Wi - fi que le téléphone',
      step2:
        "<span style=\"font-weight: bold;\">Étape 2:</span> appuyez sur l'écran de projection TV dans le coin supérieur droit du lecteur startimes app sur le téléphone pour accéder à l'interface de projection, sélectionnez le périphérique de projection sur lequel vous avez téléchargé l'application startimes pour terminer la projection."
    }
  }
}
